// extracted by mini-css-extract-plugin
module.exports = {"breakpointMedium":"720px"};